import { render } from "./Synchronization.vue?vue&type=template&id=294b0d67"
import script from "./Synchronization.vue?vue&type=script&lang=ts"
export * from "./Synchronization.vue?vue&type=script&lang=ts"

import "./Synchronization.vue?vue&type=style&index=0&id=294b0d67&lang=scss"
script.render = render

export default script